import axios from "axios";
import Cookies from "js-cookie";
// import { useDispatch } from "react-redux";

const endPoint = process.env.REACT_APP_API_ENDPOINT;
const unifiedEndPoint = process.env.REACT_APP_UNIFIED_API_ENDPOINT;

const apiConfig = (flag = false) => {
  if (Cookies.get("accessToken")) {
    return {
      headers: {
        Authorization: `bearer ${Cookies.get("accessToken")}`,
        "Content-Type": flag ? "multipart/form-data" : "application/json",
      },
      method: "PUT,DELETE,POST,GET,OPTION",
    };
  }
  return { withCredentials: false };
};

export const getApi = async (url?: string, params?: any) => {
  try {
    const response = await axios.get(`${endPoint}${url}`, {
      params: params,
      ...apiConfig(),
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const postApi = async (url: string, apiData?: any, flag?: boolean) => {
  try {
    const response = await axios.post(
      `${endPoint}${url}`,
      apiData,
      apiConfig(flag)
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const putApi = async (url: string, apiData: any, flag?: boolean) => {
  try {
    const response = await axios.put(
      `${endPoint}${url}`,
      apiData,
      apiConfig(flag)
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const patchApi = async (url: string, apiData: any, flag?: boolean) => {
  try {
    const response = await axios.patch(
      `${endPoint}${url}`,
      apiData,
      apiConfig(flag)
    );
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const putApiNoHeader = (url: string, apiData: any) => {
  if (Cookies.get("accessToken")) {
    return axios.put(`${endPoint}${url}`, apiData, {
      headers: {
        Authorization: `bearer ${Cookies.get("accessToken")}`,
      },
    });
  } else {
    // If there's no access token, return an error response or handle it as needed.
    return Promise.reject("No access token available");
  }
};

export const deleteApi = async (url: string) => {
  try {
    const response = await axios.delete(`${endPoint}${url}`, apiConfig());
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const deleteApiWithData = async (url: string, apiData?: any) => {
  try {
    const response = await axios.delete(`${endPoint}${url}`, {
      data: apiData,
      ...apiConfig(),
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const getUnifiedApi = async (
  url?: string,
  params?: any,
  headers?: any
) => {
  try {
    const response = await axios.get(`${unifiedEndPoint}${url}`, {
      params,
      headers,
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const postUnifiedApi = async (
  url: string,
  apiData?: any,
  headers?: any
) => {
  try {
    const response = await axios.post(`${unifiedEndPoint}${url}`, apiData, {
      headers,
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const putUnifiedApi = async (
  url: string,
  apiData: any,
  headers?: any
) => {
  try {
    const response = await axios.put(`${unifiedEndPoint}${url}`, apiData, {
      headers,
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};

export const deleteUnifiedApi = async (url: string, headers?: any) => {
  try {
    const response = await axios.delete(`${unifiedEndPoint}${url}`, {
      headers,
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Handle token refresh logic here
      window.location.href = "/access-denied";
    }
    throw error;
  }
};
